import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import * as blUrls from 'lib/urls'
import Navbar, { NavItem } from 'components/navbar'
import useWindowSize from 'lib/hooks/useWindowSize'

import css from './sub-nav.scss'

const renderTopic = (topics, topicSlug) =>
  topics.map((topic) => (
    <NavItem
      active={topicSlug && topicSlug == topic.slug}
      className={classNames(
        css.navItem,
        topicSlug && topicSlug == topic.slug ? css.navItemActive : ''
      )}
      href={blUrls.helloBabyPostPath(topic.slug)}
      key={topic.slug}
      router
    >
      {topic.name}
    </NavItem>
  ))

const onSearch = (searchText) => {
  location = blUrls.helloBabySearchPath(searchText)
}

const SubNav = ({ className, searchTerm, topicSlug, topics = [] }) => {
  const { width } = useWindowSize()
  let topicsToDisplay = topics
  if (width < 910) {
    topicsToDisplay = topics.slice(0, -1)
  }
  return (
    <Navbar
      className={classNames(css.navBar, className)}
      collapseAtSize="xs"
      collapseOnClick={true}
      collapseToggleElement={
        <div style={{ height: 52, lineHeight: '52px' }}>
          Topics <i className="fa fa-angle-down"></i>
        </div>
      }
      hasSearch
      searchClassName={css.searchInput}
      secondary
      searchText={searchTerm}
      searchPlaceholder="Search guides"
      onSearch={onSearch}
    >
      <NavItem
        active={!topicSlug}
        className={classNames(css.navItem, !topicSlug ? css.navItemActive : '')}
        href={blUrls.helloBabyPath}
        router
      >
        Home
      </NavItem>
      {renderTopic(topicsToDisplay, topicSlug)}
    </Navbar>
  )
}

SubNav.propTypes = {
  topicSlug: PropTypes.string,
}

export default SubNav
